import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';
import { find } from 'lodash'

import { getRegions, getCategories } from 'cityads-v3/actions/offers';
import { getTrafficTypes } from 'cityads-v3/actions/trafficTypes';
import { getWebmasterTypes } from 'cityads-v3/actions/webmasterTypes';
import { BANNED_TRAFFIC_TYPE_IDS } from 'cityads-v3/reducers/trafficTypes';

import { deepCompare } from 'cityads-v3/utils/arrayUtils';

import {
  setForm,
  saveForm,
  setError,
} from 'cityads-v3/actions/welcomeform';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from 'cityads-v3/components/TextField/TextField';
import WaitingButton from 'cityads-v3/components/Buttons/WaitingButton';

import AddLocationOutlinedIcon from '@material-ui/icons/AddLocationOutlined';
import PermContactCalendarOutlinedIcon from '@material-ui/icons/PermContactCalendarOutlined';

import classes from './WelcomeForm.scss';

import {
  WEBMASTER_TYPE_PUBLISHER,
  WEBMASTER_TYPE_MEDIABUYER,
} from 'cityads-v3/reducers/welcomeform';

import {
  MAX_DISPLAYED_SELECTED,
  menuProps
} from './WelcomeForm';

const WORK_DESCRIPTION_MIN_LENGTH = 20;

function needTrafficSubtypes({ form, trafficTypeData }) {
  const { traffic_type } = form;
  let trafficTypeSelectItems = false;

  if (traffic_type) {
    trafficTypeSelectItems = trafficTypeData.filter(item => +item.parent_type_traffic_id === +traffic_type);
  }

  return trafficTypeSelectItems && trafficTypeSelectItems.length;
}

function needTrafficTypeUrl({ form, trafficTypeDataById }) {
  const { traffic_type } = form;

  return trafficTypeDataById[traffic_type] && trafficTypeDataById[traffic_type].need_url;
}

export function checkFields({ dispatch, form, trafficTypeData, trafficTypeDataById, inline }) {
  const { webmaster_type } = form;
  const errors = {};

  errors.categories = !form.categories || !form.categories.length;
  errors.geo = !form.geo || !form.geo.length;

  errors.traffic_type = [WEBMASTER_TYPE_MEDIABUYER, WEBMASTER_TYPE_PUBLISHER].indexOf(webmaster_type) !== -1 && (!form.traffic_type || !form.traffic_type.length);

  errors.traffic_subtypes = needTrafficSubtypes({ form, trafficTypeData }) && (!form.traffic_subtypes || !form.traffic_subtypes.length);
  errors.traffic_type_url = needTrafficTypeUrl({ form, trafficTypeDataById }) && (!form.traffic_type_url || !form.traffic_type_url.length);

  if (!inline && (!form.work_description || form.work_description.length < WORK_DESCRIPTION_MIN_LENGTH)) {
    errors.work_description = true;
  }

  dispatch(setError(errors));

  return Object.keys(errors).filter(item => errors[item]).length === 0;
}

export function getTrafficTypeDataFromState(state) {
  const trafficTypeData = (state.webmasterTypes.webmasterTypesById[state.welcomeform.formData.webmaster_type] || {type_traffic: []})
    .type_traffic
    .map(item => ({...item, ...state.trafficTypes.trafficTypesById[item.type_traffic_id]}));

  return {
    trafficTypeData,
    trafficTypeDataById: trafficTypeData.reduce((prev,next) => ({...prev, [next.id]: next}), {}),
  };
}

@connect(state => ({
  form: state.welcomeform.formData,
  contacts: state.welcomeform.formData.contacts,
  errors: state.welcomeform.errors,
  curPage: state.welcomeform.curPage,

  language: state.language.language,

  isLoadedActionTypeDirections: state.actionTypeDirections.isLoaded,
  isLoadedCategories: state.offers.isLoadedCategories,
  isLoadedRegions: state.offers.isLoadedRegions,
  isLoadedTrafficTypes: state.trafficTypes.isLoaded,
  isLoadedWebmasterTypes: state.webmasterTypes.isLoaded,
  isSavingForm: state.welcomeform.isSavingForm,

  categoriesData: state.offers.category_id,
  categoriesById: state.offers.categoriesById,
  regionData: state.offers.region_id[0]?.items || [],
  regionsById: state.offers.regionsById,
  ...getTrafficTypeDataFromState(state),
}))
@withTranslation(['Welcome', 'main'], { i18n, wait: !!window })
export default class Step3 extends Component {

  static propTypes = {
    isLoadedActionTypeDirections: PropTypes.bool,
    isLoadedCategories: PropTypes.bool,
    isLoadedRegions: PropTypes.bool,
    isLoadedTrafficTypes: PropTypes.bool,
    isLoadedWebmasterTypes: PropTypes.bool,
    isSavingForm: PropTypes.bool,

    language: PropTypes.string,

    dispatch: PropTypes.func.isRequired,
  }

  state = {
    categories: []
  }

  componentDidMount() {
    const {
      isLoadedRegions,
      isLoadedCategories,
      isLoadedTrafficTypes,
      isLoadedWebmasterTypes,
      dispatch
    } = this.props;

    if (!isLoadedCategories) {
      dispatch(getCategories());
    }

    if (!isLoadedRegions) {
      dispatch(getRegions());
    }

    if (!isLoadedTrafficTypes) {
      dispatch(getTrafficTypes());
    }

    if (!isLoadedWebmasterTypes) {
      dispatch(getWebmasterTypes());
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (this.props.curPage !== newProps.curPage && newProps.curPage === 1) {
      this.checkFields(newProps);
    }
  }

  componentDidUpdate(prevProps) {
    const { dispatch, language } = this.props;

    if (language !== prevProps.language) {
      dispatch(getCategories());
      dispatch(getRegions());
      dispatch(getTrafficTypes());
      dispatch(getWebmasterTypes());
    }
  }

  goNext() {
    if (this.checkFields()) {
      this.props.dispatch(saveForm('traffic_info'))
        .then(() => {
          this.props.dispatch(setForm({
            data: {},
            page: 4
          }));
        })
      ;
    }

  }

  goPrev() {
    this.props.dispatch(setForm({
      data: {},
      page: 2
    }));
  }

  handleChangeForm(name, newValue) {
    const { dispatch } = this.props;

    this.checkField(name, newValue);

    dispatch(setForm({
      data: {
        [name]: newValue
      },
      page: 3
    }));
  }

  checkField(name, newValue) {
    const { errors, dispatch, form } = this.props;
    const newForm = {
      ...form,
      [name]: newValue
    };
    const newErrors = {
      ...errors,
      [name]: !(newForm[name] && newForm[name].length)
    }

    if (!deepCompare(newErrors, errors)) {
      dispatch(setError(newErrors));
    }
  }

  checkFields(props = this.props) {
    const { form, dispatch, trafficTypeData, trafficTypeDataById, inline } = props;

    return checkFields({ form, dispatch, trafficTypeData, trafficTypeDataById, inline });
  }

  render() {
    const {
      t,
      regionData,
      categoriesData,
      categoriesById,
      regionsById,
      trafficTypeData,
      trafficTypeDataById,
      errors,
      inline,
      inlineClasses = {},
      form,
      isSavingForm,
      language,
    } = this.props;

    const {
      webmaster_type,
      categories = [],
      geo = [],
      traffic_type,
      traffic_subtypes = [],
      traffic_type_url = '',
      work_description = '',
      work_experience = '',
    } = form;

    let trafficTypeSelectItems = false;

    const topGeoIds = regionData.map(item => +item.id);

    if (traffic_type) {
      trafficTypeSelectItems = trafficTypeData.filter(item => +item.parent_type_traffic_id === +traffic_type);
    }


    return (
      <div className={classNames(classes.form, classes.form__step3, inlineClasses.root)}>

        {!inline && (
          <div className={classes.form__title}>
            {t('step3')}
          </div>
        )}

        <div className={classNames(classes.form__items, inlineClasses.formItems)}>

          <div className={classes.form__item}>
            <PermContactCalendarOutlinedIcon className={classes.form__item_icon} />

            <TextField
              select
              SelectProps={{
                multiple: true,
                ...menuProps,
                renderValue: selected => selected
                  .filter(id => (categoriesById[id] && categoriesById[id].category_ids[0] === id))
                  .map(id => categoriesById[id]?.name)
                  .filter(name => !!name)
                  .join(', ')
              }}
              label={t('fields.categories')}
              value={categories}
              fullWidth={true}
              error={!!errors.categories}
              helperText={errors.categories ? t('errorEmptyField') : undefined}
              onChange={evt => {
                const { value } = evt.target;
                const categories = value.reduce((acc, categoryId) => {
                  const categoryItem = find(categoriesData, item => item.category_ids[0] === categoryId);

                  if (categoryItem && categoryItem.category_ids) {
                    return [...acc, ...categoryItem.category_ids];
                  }

                  return acc;
                }, []);
                this.handleChangeForm('categories', categories);
              }}
            >
              {categoriesData.map(item => (
                <MenuItem
                  key={item.category_ids[0]}
                  value={item.category_ids[0]}
                >
                  <Checkbox color="primary" checked={categories.indexOf(item.category_ids[0]) > -1} />
                  <ListItemText primary={item.name} />
                </MenuItem>
              ))}
            </TextField>
          </div>

          <div className={classes.form__item}>
            <AddLocationOutlinedIcon className={classes.form__item_icon} />

            <TextField
              select
              SelectProps={{
                multiple: true,
                ...menuProps,
                renderValue: selected => selected
                  .slice(0, MAX_DISPLAYED_SELECTED - 1)
                  .map(item => regionsById[item]?.name)
                  .filter(name => !!name)
                  .join(', ')
              }}
              label={t('fields.geo')}
              value={geo.filter(id => topGeoIds.indexOf(+id) !== -1)}
              fullWidth={true}
              error={!!errors.geo}
              helperText={errors.geo ? t('errorEmptyField') : undefined}
              onChange={evt => {
                this.handleChangeForm('geo', evt.target.value)
              }}
            >
              {regionData.map(item => (
                <MenuItem
                  key={item.id}
                  value={item.id}
                >
                  <Checkbox color="primary" checked={geo.indexOf(item.id) > -1} />
                  <ListItemText primary={item.name} />
                </MenuItem>
              ))}
            </TextField>
          </div>

          {[WEBMASTER_TYPE_MEDIABUYER, WEBMASTER_TYPE_PUBLISHER].indexOf(webmaster_type) !== -1 && (
            <div className={classes.form__item}>
              <PermContactCalendarOutlinedIcon className={classes.form__item_icon} />

              <TextField
                select
                SelectProps={{
                  multiple: false,
                  ...menuProps
                }}
                value={traffic_type ? ''+traffic_type : ''}
                label={t('fields.traffic_type')}
                fullWidth={true}
                error={!!errors.traffic_type}
                helperText={errors.traffic_type ? t('errorEmptyField') : undefined}
                onChange={evt => {
                  this.handleChangeForm('traffic_type', evt.target.value);
                  this.handleChangeForm('traffic_subtypes', []);
                }}
              >
                {trafficTypeData.filter(item => (
                  !item.parent_type_traffic_id
                  && (
                    language !== 'ru' || !BANNED_TRAFFIC_TYPE_IDS.includes(+item.id)
                  )
                )).map(item => (
                  <MenuItem
                    key={item.id}
                    value={''+item.id}
                  >{item.name}</MenuItem>
                ))}
              </TextField>
            </div>
          )}

          {(needTrafficSubtypes({ form, trafficTypeData }) && (
            <div className={classes.form__item}>
              <PermContactCalendarOutlinedIcon className={classes.form__item_icon} />

              <TextField
                select
                SelectProps={{
                  multiple: true,
                  ...menuProps,
                  renderValue: selected => selected
                    .map(item => trafficTypeDataById[item]?.name)
                    .filter(name => !!name)
                    .join(', ')
                }}
                label={trafficTypeDataById[traffic_type]?.name}
                value={traffic_subtypes}
                fullWidth={true}
                error={!!errors.traffic_subtypes}
                helperText={errors.traffic_subtypes ? t('errorEmptyField') : undefined}
                onChange={evt => {
                  this.handleChangeForm('traffic_subtypes', evt.target.value)
                }}
              >
                {trafficTypeSelectItems.map(item => (
                  <MenuItem
                    key={item.id}
                    value={item.id}
                  >
                    <Checkbox color="primary" checked={traffic_subtypes.indexOf(item.id) > -1} />
                    <ListItemText primary={item.name} />
                  </MenuItem>
                ))}
              </TextField>
            </div>
          )) || false}

          {needTrafficTypeUrl({ form, trafficTypeDataById }) ? (
            <div className={classes.form__item}>
              <PermContactCalendarOutlinedIcon className={classes.form__item_icon} />

              <TextField
                label={t('fields.traffic_type_url')}
                fullWidth={true}
                value={traffic_type_url || ''}
                onChange={evt => this.handleChangeForm('traffic_type_url', evt.target.value)}
                error={!!errors.traffic_type_url}
                helperText={errors.traffic_type_url ? t('errorEmptyField') : undefined}
              />
            </div>
          ) : null}

          {inline ? undefined : (
            <div className={classes.form__item}>
              <PermContactCalendarOutlinedIcon className={classes.form__item_icon} />

              <TextField
                label={t('fields.work_description')}
                placeholder={t('fields.work_description_placeholder')}
                fullWidth={true}
                value={work_description || ''}
                onChange={evt => this.handleChangeForm('work_description', evt.target.value)}
                error={!!errors.work_description}
                helperText={errors.work_description ? (work_description ? t('errorTooShortField') : t('errorEmptyField')) : undefined}
                minLength={20}
              />
            </div>
          )}

          {inline ? (
            <div className={classes.form__item}>
              <PermContactCalendarOutlinedIcon className={classes.form__item_icon} />

              <TextField
                label={t('fields.work_experience')}
                fullWidth={true}
                maxLength={300}
                renderMinMaxLength={false}
                value={work_experience || ''}
                onChange={evt => this.handleChangeForm('work_experience', evt.target.value)}
              />
            </div>
          ) : null}

        </div>

        {!inline && (
          <div className={classes.buttons}>
            <Button variant="contained" onClick={() => this.goPrev()}>{t('main:buttons.back')}</Button>
            <WaitingButton
              variant = "contained"
              color   = "primary"
              onClick = {() => this.goNext()}
              waiting = {isSavingForm}
            >
              {t('continue')}
            </WaitingButton>
          </div>
        )}
      </div>
    );
  }

}
